<script>
import BaseComp from './BaseComp'
import OrgPermission from './Permission/OrgPermission'
import UserPermission from './Permission/UserPermission'

export default {
  name: 'columnPermission',
  extends: BaseComp,
  components: {
    OrgPermission,
    UserPermission
  },
  data () {
    return {
      dataType: 2,
      currentTab: 'org',
      tabs: [
        {
          label: '组织及角色',
          name: 'org',
          component: 'OrgPermission'
        },
        {
          label: '用户',
          name: 'user',
          component: 'UserPermission'
        }
      ]
    }
  },
  computed: {
    columnHeaders () {
      return {
        content: '这里是栏目权限管理',
        title: '操作说明：'
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
